<template lang="html">
    <div 
        class="plaque-moteur"
        :class="isAdvanced?'advanced-section':''"
    >
        <!-- <div class="plaque-moteur-frame"> -->
            <h2 class="step-title">Plaque moteur</h2>
            <el-form-item
                class="rowNominalPower"
                prop="nominal_power"
                label="Puissance nominale (kW)"
                :show-message="showMessage('nominal_power')"
            >
                <el-input
                    v-model="motorForm.nominal_power"
                    required
                    :controls="false"
                    :precision="0"
                    :min="1"
                    :max="9999"
                    type="number"
                ></el-input>
            </el-form-item>
            <el-row :gutter="24">
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item
                        label="Tension nominale (V)"
                        prop="nominal_voltage"
                        :show-message="showMessage('nominal_voltage')"
                    >
                        <el-tooltip
                            class="formTooltip"
                            placement="right"
                            content="Doit être comprise entre 380 et 400 V"
                        >
                            <el-input
                                type="number"
                                v-model="motorForm.nominal_voltage"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item
                        label="Courant nominal (A)"
                        prop="nominal_current"
                        :show-message="showMessage('nominal_current')"
                    >
                        <el-tooltip
                            class="formTooltip"
                            effect="dark"
                            placement="right"
                            content="Doit être comprise entre 3 et 2000 A"
                        >
                            <el-input
                                type="number"
                                v-model="motorForm.nominal_current"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item
                        label="Cos Phi"
                        prop="cos_phi"
                        :show-message="showMessage('cos_phi')"
                    >
                        <el-tooltip
                            class="formTooltip"
                            effect="dark"
                            placement="right"
                            content="Doit être comprise entre 0.6 et 0.95"
                        >
                            <el-input
                                type="number"
                                step="0.001"
                                v-model="motorForm.cos_phi"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col
                    :xs="24"
                    :md="12"
                >
                    <el-form-item
                        label="Vitesse nominale (tr/min)"
                        prop="nominal_speed"
                        :show-message="showMessage('nominal_speed')"
                    >
                        <el-tooltip
                            class="formTooltip"
                            effect="dark"
                            placement="right"
                            content="Plage de vitesses supportées : 1 400 - 1 500 tr/min et 2 900 - 2 999 tr/min"
                        >
                            <el-input
                                type="number"
                                v-model="motorForm.nominal_speed"
                                required
                            ></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-form-item 
                v-if="isAdvanced"
                prop="casing_type" 
                class="formSelect" 
                :show-message="showMessage('casing_type')" 
                label="Type de structure"
            >
                <el-select name="carcasse" id="carcasse" v-model="motorForm.casing_type" placeholder="Choisissez un type de structure" required>
                    <el-option
                        v-for="label, opt  in $store.state.casings"
                        :key="opt"
                        :label="label"
                        :value="opt"
                    >
                        {{label}}
                    </el-option>
                </el-select>
            </el-form-item> -->
        <!-- </div> -->
    </div>
</template>

<script>

export default {
    data() {
        return {
        };
    },
    props: {
        motorForm: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        },
        isAdvanced:{
            type: Boolean,
            required: false,
            default: false,
        }
    },
    computed: {
        getNominalPowerChoices() {
            // En dur car dans une version ultérieure on aura juste un input-number
            return [
                2.2,3,4,5.5,7.5,11,15,18.5,22,30,37,45,55,75,90,110,132,160,
                200,250,280,315,355,400,450,500,560,630,710,800,900,1000
            ];
        },
    },
    methods: {
        showMessage(el) {
            if (this.motorForm[el] && this.motorForm[el].length){
                return true;
            } else {
                return false;
            }
        },
    }
};
</script>

<style lang="less">

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outter-spin-button {
    -webkit-appearance: none;
}

.plaque-moteur {
    width: 80%;
    box-sizing: border-box;
    .el-row {
        position: static;
    }
    .el-col {
        max-height: 90.5px;
    }
    .el-form-item {
        width: 95%;
    }
    .rowNominalPower {
        flex-wrap: wrap;
        position: relative;
        .el-form-item__content {
            position: static;
            .el-row {
                position: static;
                .el-radio-group {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: space-around;
                    width: 100%;
                    margin: 20px 0;
                }
            }
        }
        .nominalPowerChoices {
            display: block;
            position: static;
            margin: 0 0 20px;
            input {
                // display: none;
                position: static;
            }
            span {
                padding: 10px 0 !important;
                position: static;
                display: block;
            }
        }
        .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        }
        .el-radio-button:focus:not(.is-focus):not(:active) {
            box-shadow: none;
        }
        .el-radio-button__inner:hover {
        }
    }
}
.plaque-moteur-frame {
    padding: 5px 15px 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    border: 5px solid #efefef !important;
    i {
        display: block;
        margin: 0 0 0 15px;
    }
    .noSwitchMotorInfo {
        margin: 30px 5% 5% 0;
    }
}
// .moteur-header {
//     padding-bottom: 50px;
// }
.select-regulation, .select-application {
    margin-top: 40px;
    margin-bottom: 40px;
    .regulation-type, .application-type {
        display: block;
        width: 100%;
    }
    // .regulation-type-desc {
    //     display:block;
    //     width: 100%;
    //     font-size: 11px;
    //     line-height: 13px;
    //     margin-top: 20px;
    //     margin-bottom: 10px;
    //     .regulation-type-img {
    //         display:block;
    //         text-align: center;
    //         padding-bottom: 10px;
    //         img {
    //             max-width: 100%;
    //             max-height: 80px;
    //             margin: auto;
    //         }
    //     }
    // }
}
// .moteur-body {
//     display: block;
//     position: relative;
// }
h2 {
    width: 100%;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
}

.main {
    width: 100%;
}

.el-tooltip__popper.formTooltip {
    color: black !important;
    .popper__arrow {
    }
    .popper__arrow::after {
    }
}

.formSelect {
    .el-select {
        margin: 0;
        width: 100%;
        input {
            padding: 0 20px;
        }
    }
}

.el-select .el-input.is-focus .el-input__inner {
}
.step-title{
    color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/wizard/PlaqueMoteurForm.vue